import { CallPhase } from '@web-app/utils/tagActions/types';
import React from 'react';

export { CallPhase };

export interface PayerAction {
  id: string;
  title: string;
  description?: string;
  renderAction: () => React.ReactNode;
}

export interface PayerActionRule {
  id: string;
  phase: CallPhase;
  payerIds: string[];
  actions: PayerAction[];
}
